// extracted by mini-css-extract-plugin
module.exports = {"attraction":"Attraction_attraction__vkdMd","attraction__heading":"Attraction_attraction__heading__fTXqq"};